import type { JSX } from 'react';

import { CmsHtml } from 'src/app/shared/components/cms';

import { usePageBody } from './hooks/usePageBody';

export function PageBody(): JSX.Element {
	const {
		data: { content, styles },
	} = usePageBody();

	return (
		<div className="container py-14">
			<CmsHtml html={content} styles={styles} />
		</div>
	);
}
